"use client";

import { TurnstileWidget } from "@/components/login/turnstile-widget";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowRight, Loader2 } from "lucide-react";

interface EmailStepProps {
  email: string;
  setEmail: (email: string) => void;
  isSending: boolean;
  canSubmitEmail: boolean;
  errorMsg?: string;
  turnstileSiteKey: string;
  turnstileResetKey: number;
  onTurnstileToken: (token: string) => void;
  onSubmit: () => void;
  onCancel?: () => void;
}

export function EmailStep({
  email,
  setEmail,
  isSending,
  canSubmitEmail,
  errorMsg,
  turnstileSiteKey,
  turnstileResetKey,
  onTurnstileToken,
  onSubmit,
  onCancel,
}: EmailStepProps) {
  return (
    <>
      <div className="mt-2">
        <p>Email</p>
      </div>
      <div>
        <Input
          type="email"
          placeholder="jkrowling@gmail.com"
          autoFocus
          value={email}
          disabled={isSending}
          onChange={(event) => setEmail(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && canSubmitEmail) {
              event.preventDefault();
              onSubmit();
            }
          }}
        />
      </div>

      {errorMsg ? <p className="text-xs text-destructive font-medium">{errorMsg}</p> : null}

      <div className="mt-2">
        <p className="text-xs italic">We will send you a confirmation code.</p>
        <p className="mt-2 text-xs italic">We'll create an account automatically if you don't already have one.</p>
      </div>

      <TurnstileWidget siteKey={turnstileSiteKey} resetKey={turnstileResetKey} onToken={onTurnstileToken} />

      <div className="mt-5 flex gap-2.5 w-full">
        {onCancel ? (
          <Button type="button" variant="outline" disabled={isSending} className="flex-1 cursor-pointer" onClick={onCancel}>
            Cancel
          </Button>
        ) : null}
        <Button
          type="button"
          disabled={!canSubmitEmail}
          className={onCancel ? "flex-1 cursor-pointer" : "w-full cursor-pointer"}
          onClick={onSubmit}
        >
          {isSending ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>Sending</span>
            </>
          ) : (
            <>
              <span>Continue</span>
              <ArrowRight className="w-4 h-4" />
            </>
          )}
        </Button>
      </div>
    </>
  );
}
